<div class="header">
    <h3 class="title">{{ 'coupons.edit.customer.items.addItems' | translate }}</h3>
</div>

<div class="messages">
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="InvalidIdsError"
                 *ngIf="invalidIdsError">
        <span *ngIf="invalidIdsList.length > 0">
            {{ 'coupons.edit.customer.items.invalidIdsError' | translate }}: {{ invalidIdsList.join(', ') }}
        </span>
        <span *ngIf="invalidIdsList.length === 0">
            {{ 'coupons.edit.customer.items.invalidIdsError' | translate }}
        </span>
    </txp-message>
</div>

<div class="form-content">
    <div class="coupon-items-add" *ngIf="data.dialogType === 'search'">
        <div class="product-content">
            <txp-type-selector class="order-charge-type-selector"
                               [selected]="itemTypeSelected"
                               [types]="itemTypes"
                               [columns]="itemTypes.length"
                               (select)="onSelectItem($event)">
            </txp-type-selector>

            <ng-container *ngFor="let list of lists; let i = index">
                <txp-item-list *ngIf="itemTypeSelected === itemTypes[i]?.data"
                               class="item-list"
                               [disableSelectionReset]="false"
                               [data]="list"
                               (emitSelection)="getSelectedCatalog($event)"
                               [enableMultiSelect]="true"
                               [enableSelection]="true"
                               [filterText]="'menu.common.search' | translate"
                               [header]="itemTypes[i].label"
                               listKey="name">
                </txp-item-list>
            </ng-container>
        </div>

        <div class="actions">
            <i class="tce-icon-arrow-right arrow"></i>
            <txp-button (click)="onAdd()"
                        data-qa-label="AddButton"
                        [style]="buttonStyle.SECONDARY"
                        [disabled]="false">
                {{ 'menu.createMenu.add' | translate }}
            </txp-button>
        </div>

        <div class="selected-content">
            <div class="title">{{ 'menu.createMenu.items' | translate }}</div>
            <div class="items-list">
                <div class="items-box" *ngFor="let item of addedItemsList">
                    <span class="product-name"> {{ item.name }} </span>
                    <span class="remove-icon">
                        <i class="tce-icon-trash" (click)="onDelete(item)"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="coupon-items-add" *ngIf="data.dialogType === 'add'">
        <mat-form-field class="textarea-container" [formGroup]="form">
            <mat-label>{{ 'coupons.edit.customer.items.add' | translate }}</mat-label>
            <textarea data-qa-label="AddIdsInput"
                      matInput
                      class="full-width"
                      resize="none"
                      (blur)="onAddIds()"
                      formControlName="itemIds">
            </textarea>

            <mat-hint>
                {{ 'coupons.edit.customer.items.addIdsHint' | translate }}
            </mat-hint>
            <mat-error *ngIf="addedItemIds.length && !form.valid">
                {{ 'coupons.edit.customer.items.invalidFormat' | translate }}
            </mat-error >
        </mat-form-field>
    </div>
</div>

<div class="actions">
    <txp-button (click)="onCancel()"
                data-qa-label="CancelButton"
                [disabled]="isLoading"
                [style]="buttonStyle.SECONDARY">
        {{ 'form.button.cancel' | translate }}
    </txp-button>
    <txp-button data-qa-label="DoneButton"
                [disabled]="isLoading || !form.valid"
                [loading]="isLoading"
                [style]="buttonStyle.PRIMARY"
                (click)="onDone()">
        {{ 'menu.createMenu.done' | translate }}
    </txp-button>
</div>